import React from 'react';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { Grid } from '@mui/material';
import { ContentSpacer } from '../layout/generic-content-spacer';
import { tcsmColors } from '../../constants/theme/theme-constants/colors';
import { labelValueStyles } from '../../constants/theme/styles/components/label-value-styles';

interface Props {
    label: string | JSX.Element;
    value: string | JSX.Element | number;
    tooltipMessage?: string;
    fullSpanLabel?: boolean;
}
export function LabelAndValue(props: Props) {
    const classes = labelValueStyles();
    const renderLabel = (label: string | JSX.Element ) => {
        if (typeof label === 'string' ) {
            return (
                <p><strong>{label}</strong></p>
            );
        }

        return label;
    };
    const renderValue = (value: string | JSX.Element | number) => {
        if (typeof value === 'string' || typeof value === 'number') {
            return (
                <p>{value}</p>
            );
        }

        return value;
    };

    return (
        <>
            <ContentSpacer>
                <Grid container>
                    <Grid item xs={12} md={6} className={classes.labelViewRow}>
                        <div className={`row-header ${props.fullSpanLabel ? 'full-span' : ''}`}>
                            {renderLabel(props.label)}
                            <div className='row-tooltip'>
                                {props.tooltipMessage && <Tooltip iconColor={tcsmColors.blue} title={props.tooltipMessage} />}
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {renderValue(props.value)}
                    </Grid>
                </Grid>
            </ContentSpacer>
        </>
    );
}

LabelAndValue.defaultProps = {
    tooltipMessage: '',
    fullSpanLabel: false,
};